import { FunctionComponent, memo } from 'react';
import { FeedCardProps, FeedCardThreadCommon } from '../../../shared';

export const FeedCardThread: FunctionComponent<FeedCardProps> = memo((props) => {
  return <FeedCardThreadCommon {...props} />;
});
